module.exports = __webpack_public_path__ + "media/images/icons/project-3fd167a2ff3a0ca31a24b8ad3654f790.svg";